<!--&================== TITLE ADMINISTRATOR ==================&-->
<div class="title-components">
  <h1>Tipo de papelera en Processes</h1>
</div>

<!--&================== CONTENT CARDS ==================&-->
<div class="Content-Tasks">
  <div [routerLinkActive]="'active'" *ngFor="let CardAdmin of AllRecycleBin" class="Card-Task">
    <div class="Content-Card">
      <div class="Card-Notification">
        <div class="notifications button-square">
          <i class="{{CardAdmin.Icon}}"></i>
        </div>
      </div>
      <div class="Body-Card">
        <div class="Title-Card">
          <h2>{{CardAdmin.Title}}</h2>
        </div>
        <div class="Subtitle-Card">{{GetGreeting()}}, {{NameUser()}}, {{CardAdmin.Description}}</div>
      </div>
    </div>
    <div class="Btn-See-Task">
      <a routerLink="{{CardAdmin.RouteLink}}" class="Btn-Task btn-icon-text-left">
        <span class="text">{{CardAdmin.ButtonText}}</span><i class="{{CardAdmin.IconButton}}"></i>
      </a>
    </div>
  </div>
  <div class="SPACE"></div>
  <div class="SPACE"></div>
</div>

